export const initialState = {
  mode: "POST",
  garmentIdSelected: 0,
  defaultData: {},
  //   defaultDataDetail: null,
};

export const SET_MODE = "[GARMENT] SET_MODE";
export const SET_GARMENT_ID = "[GARMENT] SET_GARMENT_ID";
export const SET_DEFAULT_DATA = "SET_DEFAULT_DATA";
// export const SET_DEFAULT_DATA_DETAIL = "[GARMENT] SET_DEFAULT_DATA_DETAIL";

export const setMode = (payload) => ({
  type: SET_MODE,
  payload,
});

export const setGarmentIds = (payload) => ({
  type: SET_GARMENT_ID,
  payload,
});

export const setDefaultData = (payload) => ({
  type: SET_DEFAULT_DATA,
  payload,
});

export default function Reducer(state = initialState, { type, payload }) {
  switch (type) {
    case SET_MODE:
      return {
        ...state,
        mode: payload,
      };
    case SET_GARMENT_ID:
      return {
        ...state,
        garmentIdSelected: payload,
      };
    case SET_DEFAULT_DATA:
      return {
        ...state,
        defaultData: payload,
      };
    default:
      return state;
  }
}
